import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  private msalBroadcastService = inject(MsalBroadcastService);

  constructor(
    private msalService: MsalService,
    private router: Router
  ) {}

  async canActivate(): Promise<boolean> {
    try {
      await firstValueFrom(
        this.msalBroadcastService.inProgress$.pipe(
          filter((status) => status === InteractionStatus.None)
        )
      );

      let account = this.msalService.instance.getActiveAccount();
      if (!account) {
        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          account = accounts[0];
          this.msalService.instance.setActiveAccount(account);
        }
      }

      if (!account) {
        this.msalService.loginRedirect();
        return false;
      }

      const roles = (account?.idTokenClaims as any)?.roles as string[];
      if (roles && roles.length > 0) {
        return true;
      }

      this.router.navigate(['/not-authorized']);
      return false;
    } catch (error) {
      console.error('RoleGuard error:', error);
      this.router.navigate(['/not-authorized']);
      return false;
    }
  }
}
